export default "__VITE_ASSET__BwkZFL_e__"